module.exports = __webpack_public_path__ + "static/media/16.abdfff6c.jpg";